import visualDropdown from '~/components/Organisms/Organic/VisualDropdown/VisualDropdown.vue'
import hotIcon from '~/components/Molecules/Icon/Icon.vue'
import headerBarMenu from '~/components/Organisms/Organic/HeaderBarMenu/HeaderBarMenu.vue'
import footerBarMenu from '~/components/Organisms/Organic/FooterBarMenu/FooterBarMenu.vue'

export default {
  components: {
    visualDropdown,
    hotIcon,
    headerBarMenu,
    footerBarMenu,
  },

  props: {
    navigation: {
      type: Array,
      required: false,
    },

    plattaform: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      openSubMenus: [],
    }
  },

  methods: {
    isAnchor(href) {
      return /^(https?:\/\/|\/\/)/.test(href) && /#[\w-]+/.test(href)
    },

    isOpen(index) {
      return this.openSubMenus.includes(index)
    },

    isActive(index) {
      return this.openSubMenus.some(i => i === index)
    },

    toggleDropdown(index) {
      if (this.isOpen(index)) {
        this.openSubMenus = []
        this.$emit('dropdown-open', false)
      } else {
        this.openSubMenus = [index]
        this.$emit('dropdown-open', true)
      }
    },

    closeDropdown() {
      this.openSubMenus = []
      this.$emit('dropdown-open', false)
    },

    close() {
      this.openSubMenus = []
      this.$emit('dropdown-open', false)
      this.$emit('menu-open', false)
    },

    back() {
      this.close()
    },
  },
}
